// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__Sp7JC","borderLeft":"styles_borderLeft__FsbEU","freqColumn":"styles_freqColumn__Em8yK","wordCloud":"styles_wordCloud__246iM"};